var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"secondary-btn-container",class:_vm.rootClassName},[_c('button',{staticClass:"secondary-btn-button button"},[_vm._v(_vm._s(_vm.button))])])}
var staticRenderFns = []

export { render, staticRenderFns }